import {
  collection,
  getDocs,
  query,
  QueryConstraint,
  where,
} from "firebase/firestore";
import { db } from "shared/api/firebase";
import { ModuleData } from "../types";
import { ModuleDB } from "./Modules";

export const getModuleTemplatesListByTagId = async (
  tagId: string,
): Promise<ModuleData[]> => {
  try {
    const collectionRef = collection(db, "moduleTemplates");

    const params: QueryConstraint[] = [where("tags", "array-contains", tagId)];

    const q = query(collectionRef, ...params);

    const querySnap = await getDocs(q);

    return querySnap.docs.map((moduleSnap) => {
      return new ModuleDB(moduleSnap).toModule();
    });
  } catch (error) {
    console.error("Failed to retrieve modules by tagId", error);

    return [];
  }
};
